/* loaded by smart-asset */
export default require("./grapes~VvgQSJjC.png")